type AsyncProgramsSlugs =
  | 'bv-async'
  | 'cold-sores-async'
  | 'genital-herpes-async'
  | 'uti-async'
  | 'yeast-infection-async';

export type QuizIdsEnum =
  | 'uti-async-pre-purchase-quiz'
  | 'bv-async-pre-purchase-quiz'
  | 'gh-async-pre-purchase-quiz'
  | 'yi-async-pre-purchase-quiz'
  | 'cs-async-pre-purchase-quiz';

export const ASYNC_PROGRAMS_QUIZ_IDS: Record<AsyncProgramsSlugs, QuizIdsEnum> =
  {
    'bv-async': 'bv-async-pre-purchase-quiz',
    'cold-sores-async': 'cs-async-pre-purchase-quiz',
    'genital-herpes-async': 'gh-async-pre-purchase-quiz',
    'uti-async': 'uti-async-pre-purchase-quiz',
    'yeast-infection-async': 'yi-async-pre-purchase-quiz',
  };

export const LAUNCH_HASH = '#launch-ppq';
